import { render } from "./MainByUser.vue?vue&type=template&id=56ee29af&scoped=true"
import script from "./MainByUser.vue?vue&type=script&lang=js"
export * from "./MainByUser.vue?vue&type=script&lang=js"

import "./MainByUser.vue?vue&type=style&index=0&id=56ee29af&scoped=true&lang=css"
import "./MainByUser.vue?vue&type=style&index=1&id=56ee29af&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ee29af"]])

export default __exports__